import "./Work.css";
import Timeline from "./Timeline";

const Work = () => {
  return (
    <div class="work" id="experience">
      <h1>Experience</h1>
        <Timeline />
    </div>
  );
};

export default Work;
